import React, { useEffect, useState } from "react";

import "./Body.css";
import Header from "./Header";
import Cards from "../Cards/Cards";
import {
  getAllCountries,
  allCountries,
  sortByName,
  getByContinent,
  sortByPopulation,
  getCountryByName,
} from "../../redux/reducers/countries";
import { useDispatch, useSelector } from "react-redux";
import Paged from "./paged";
import LandingPage from "../LandingPage/LandingPage";

const Body = () => {
  const [nameCountry, setNameCountry] = useState("");
  const dispatch = useDispatch();
  const countries = useSelector(allCountries);
  const [currentPage, setCurrentPage] = useState(1);
  const [countriesPerPage] = useState(9);
  const indexLastCountries = currentPage * countriesPerPage;
  const indexFirstCountries = indexLastCountries - countriesPerPage;
  const currentCountries =
    countries.length > 0
      ? countries.slice(indexFirstCountries, indexLastCountries)
      : "No se ha encontrado pais";
  useEffect(() => {
    dispatch(getAllCountries());
  }, [dispatch]);

  const totalPages = (pageNumber, e) => {
    setCurrentPage(pageNumber);
    //Resaltar la pagina actual
    let active = "active";
    let desactive = "";
    let { li } = document.getElementById("listas").childNodes;
    li.forEach((element) => {
      element.className = desactive;
      if (e.target === element) {
        e.target.className = active;
      }
    });
  };
  const onChangeNumber = (e) => {
    dispatch(sortByPopulation(e.target.value, countries));
    if (e.target.value === "Numero de población") {
      dispatch(getAllCountries());
    }
  };
  const onChangeAlph = (e) => {
    dispatch(sortByName(e.target.value, countries));
    if (e.target.value === "alfabeticamente") {
      dispatch(getAllCountries());
    }
  };
  const onChangeContinent = (e) => {
    dispatch(getByContinent(e.target.value, countries));
    if (e.target.value === "Continent") {
      dispatch(getAllCountries());
    }
  };
  const onChangeName = (e) => {
    setNameCountry(e.target.value);
  };
  const findByName = () => {
    dispatch(getCountryByName(nameCountry));
    document.getElementById("name").value = "";
    setNameCountry("");
  };
  const onEnter = (e) => {
    if (e.keyCode === 13) {
      dispatch(getCountryByName(nameCountry));
      document.getElementById("name").value = "";
      setNameCountry("");
    }
  };

  return (
    <>
      <LandingPage />
      <Header />
      <div className="body-container">
        <div className="body-content">
          <div className="search-filter">
            <input
              onChange={onChangeName}
              type="text"
              id="name"
              placeholder="Write a country"
              onKeyDown={onEnter}
            />
            <button onClick={findByName}>Search</button>
            <select onChange={onChangeAlph}>
              <option>alphabetically</option>
              <option value={"AtoZ"}>A to Z</option>
              <option value={"ZtoA"}>Z to A</option>
            </select>
            <select onChange={onChangeNumber} className="selector">
              <option>Poblation</option>
              <option value="Mtom">In decreasing order</option>
              <option value="mtoM">In ascending order</option>
            </select>
            <select onChange={onChangeContinent} className="selector">
              <option>Continent</option>
              <option value="Americas">America</option>
              <option value="Europe">Europe</option>
              <option value="Africa">Afrika</option>
              <option value="Antarctic">Antarctic</option>
              <option value="Asia">Asia</option>
            </select>
          </div>
          <div className="countries-list">
            {Array.isArray(currentCountries) ? (
              currentCountries.length > 0 ? (
                currentCountries.map((country) => (
                  <Cards
                    img={country.flag}
                    name={country.name}
                    id={country.id}
                    capital={country.capital}
                  />
                ))
              ) : (
                <h4>No countries to show</h4>
              )
            ) : (
              ""
            )}
          </div>
        </div>
        <div>
          <Paged
            countriesPerPage={countriesPerPage}
            allCountries={countries.length}
            totalPages={totalPages}
          />
        </div>
      </div>
    </>
  );
};

export default Body;
